<template>
  <ClientOnly>
    <Teleport to="body">
      <Transition name="modal">
        <div
          v-if="isOpen"
          class="fixed top-0 left-0 z-[1000] flex size-full flex-col items-center justify-center overflow-hidden overscroll-none"
          :class="$attrs.class"
        >
          <button
            class="absolute top-0 left-0 size-full bg-black/75 backdrop-blur-xs"
            @click="closeModal"
          />

          <main
            class="modal-container relative z-10 mx-auto max-w-none bg-background shadow-2xl tablet:size-[700px] desktop:size-[800px] belowTablet:size-full belowTablet:overflow-y-scroll"
          >
            <button
              class="absolute top-4 right-4 z-100 size-8 shrink-0 text-primary hover:text-primary-light focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
              aria-label="Close dialog"
              @click="closeModal"
            >
              <SpriteSymbol name="close" class="size-full" />
            </button>

            <div class="h-full px-size-6 tablet:p-size-4">
              <slot />
            </div>
          </main>
        </div>
      </Transition>
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modalId: string
  card?: boolean
  title?: string
  text?: string
}>()

const { activeModal, closeModal } = useModal()

const isOpen = computed(() => props.modalId === activeModal.value)
</script>

<style>
@reference '~/assets/css/tailwind.css';
.modal-enter-active,
.modal-leave-active {
  @apply transition-all duration-300 ease-swing;

  .modal-container {
    @apply transition-all duration-300 ease-bounce;
  }
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;

  .modal-container {
    @apply translate-y-1/2 tablet:translate-y-9 tablet:scale-90;
  }
}

.modal-leave-from,
.modal-enter-to {
  opacity: 1;
}
</style>
